import { assign, merge } from 'lodash';
import types from './mutationTypes';

export default {
  [types.SET_CONFIG](state, payload) {
    merge(state.config, payload);
  },
  [types.SET_RESULTS](state, payload) {
    assign(state.results, {
      rounds: payload.rounds,
      pagination: payload.pagination,
    });

    if (payload.translations) {
      merge(state.translations, payload.translations.RouletteWeb);
    }
  },
};
